import { ApprovalErrorAlertI18nTitle, ApprovalErrorAlertI18nMessage } from './i18n/ApprovalErrorAlertI18n';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalErrorAlert = ({
  approvalType,
  errorSubCategory
}) => /*#__PURE__*/_jsx(Alert, {
  type: "danger",
  titleText: /*#__PURE__*/_jsx(ApprovalErrorAlertI18nTitle, {
    approvalType: approvalType,
    errorSubCategory: errorSubCategory
  }),
  children: /*#__PURE__*/_jsx(ApprovalErrorAlertI18nMessage, {
    approvalType: approvalType,
    errorSubCategory: errorSubCategory
  })
});